<template>
  <v-container>
    <v-row>
      <v-col>
        <div class="chapter-scroll-block" v-if="selectedSubject.chapters && selectedSubject.chapters.length">
          <div
            class="chapter-row"
            v-for="item in selectedSubject.chapters"
            :key="item.id"
          >
            <div @click="checkUncheck(item)">
              <v-checkbox
                v-if="!item.showIndexTopics"
                v-model="item.checked"
                :value="item.checked"
              ></v-checkbox>
              <v-btn
                v-else
                @click="checkUncheck(item)"
                type="button"
                class="Chapterselecttopicwise"
                ><v-icon>mdi-minus</v-icon></v-btn
              >
              <!-- <v-btn
                            v-else
                            @click="onCheckedUnchecked(item)"
                            class="rounded-btn-add"
                            color="#9E9E9E"
                        >
                            <v-icon>mdi-minus</v-icon>
                        </v-btn> -->
            </div>
            <div class="chapter-center-name">
              <v-tooltip top content-class="cust-new-tooltip-top">
                <template v-slot:activator="{ on }">
                  <div class="max-char" v-on="on">{{ item.title }}</div>
                </template>
                <span>{{ item.question_count }} Questions Available</span>
              </v-tooltip>
            </div>
            <div class="rounded-btn-add" @click="onChapterClick(item)">
              <v-btn
                v-if="!item.showTopics"
                class="rounded-btn-add custsyl"
                color="primary"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <v-btn v-else class="rounded-btn-add graayBg">
                <v-icon>mdi-minus</v-icon>
              </v-btn>
            </div>
            <div class="fullsize-outer" v-show="item.showTopics">
              <div
                class="sub-chapter-row"
                v-for="child in item.topic"
                :key="child.id"
              >
                <div>
                  <v-checkbox
                    @click="checkUncheck(child)"
                    v-model="child.checked"
                    :value="child.checked"
                  ></v-checkbox>
                </div>
                <div class="chapter-center-name">
                  <v-tooltip top content-class="cust-new-tooltip-top">
                    <template v-slot:activator="{ on }">
                      <div class="max-char" v-on="on">{{ child.title }}</div>
                    </template>
                    <span>{{ child.question_count }} Questions Available</span>
                  </v-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="no-subject">
          No chapters are available for {{ subject.title }}
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "PatternI",
  props: [
    "onBackClick",
    "data",
    "stepOneData",
    "stepTwoData",
    "subType",
    "subjects",
    "subject",
    "tab",
    "index",
    "checkUncheck",
  ],
  data() {
    return {
      dataTreeLevel: { subjects: 2, chapter: 3, topic: 4 },
      selectedSubject: {},
      selectedChatersTopics: {},
    };
  },

  mounted() {
    this.selectedSubject = this.subject;
  },
  methods: {
    onChapterClick(item) {
      let index = this.selectedSubject.chapters.findIndex(
        (c) => c.id === item.id
      );
      if (!item.showTopics) {
        this.selectedSubject.chapters[index].showTopics = true;
      } else {
        this.selectedSubject.chapters[index].showTopics = false;
      }
    },
  },
};
</script>
